import { createContext } from 'react';
import { drawerVariants, IDrawerVariants } from './drawer.variants';

export type DrawerContextProps = {
  name: string;
  variant?: keyof typeof drawerVariants | (string & {});
  variants?: IDrawerVariants;
};

export const DrawerContext = createContext<DrawerContextProps | null>(null);

export const DrawerProvider = DrawerContext.Provider;
